import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "rounded shadow-lg modal-content-container" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "pt-3 px-3" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("h6", null, [
      /*#__PURE__*/_createElementVNode("strong", null, "Current Visit Rate ")
    ])
  ])
], -1 /* HOISTED */)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("hr", { class: "mb-2" }, null, -1 /* HOISTED */)
const _hoisted_4 = { class: "px-2" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h6", null, "Customize the rate for this visit below", -1 /* HOISTED */)
const _hoisted_6 = { role: "form" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "me-3 col-2" }
const _hoisted_9 = { class: "rate-input col-8 w-75" }
const _hoisted_10 = { class: "input-group input-group-sm" }
const _hoisted_11 = { class: "input-group-prepend" }
const _hoisted_12 = {
  key: 0,
  class: "input-group-text bg-danger text-white"
}
const _hoisted_13 = {
  key: 1,
  class: "input-group-text rate-icon bg-success"
}
const _hoisted_14 = ["onUpdate:modelValue"]
const _hoisted_15 = {
  key: 0,
  class: "text-end text-danger"
}
const _hoisted_16 = { class: "mt-0 d-flex pb-2 px-3 justify-content-center" }
const _hoisted_17 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      _createElementVNode("form", _hoisted_6, [
        (_ctx.payRates && _ctx.payRates.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.payRates, (rate) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "mb-3 row",
                  key: rate.id
                }, [
                  _createElementVNode("span", _hoisted_8, _toDisplayString(rate.Label), 1 /* TEXT */),
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("div", _hoisted_11, [
                        (_ctx.isBelowMinRate(_ctx.Rate, _ctx.MinRate))
                          ? (_openBlock(), _createElementBlock("span", _hoisted_12, "!"))
                          : (_openBlock(), _createElementBlock("span", _hoisted_13, "$"))
                      ]),
                      _withDirectives(_createElementVNode("input", {
                        type: "number",
                        "onUpdate:modelValue": ($event: any) => ((rate.Rate) = $event),
                        class: "form-control"
                      }, null, 8 /* PROPS */, _hoisted_14), [
                        [_vModelText, rate.Rate]
                      ])
                    ]),
                    (_ctx.isBelowMinRate(_ctx.Rate, _ctx.MinRate))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_15, " Min: " + _toDisplayString(rate.MinRate), 1 /* TEXT */))
                      : _createCommentVNode("v-if", true)
                  ])
                ]))
              }), 128 /* KEYED_FRAGMENT */))
            ]))
          : _createCommentVNode("v-if", true)
      ]),
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("button", {
          disabled: !_ctx.areRatesAboveMin,
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.savePayRates && _ctx.savePayRates(...args))),
          type: "button",
          class: "btn btn-xs me-2 btn-outline-primary"
        }, " Save ", 8 /* PROPS */, _hoisted_17),
        _createElementVNode("button", {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.cancel())),
          type: "button",
          class: "btn btn-xs btn-primary"
        }, "Cancel")
      ])
    ])
  ]))
}